import { SaveOrderPayload } from '@fingermarkglobal/types';
import { saveOrder } from '../requests/save-order';
import { createMachine, assign } from 'xstate';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;
    
    if (data) {
      logger.debug(`[@fingermarkglobal/api]: Save order FSM data recieved:`, data);
      return data
    };

    if (error) {
      logger.error(`[@fingermarkglobal/api]: Save order FSM error recieved:`, error);
      return error
    };

    logger.error(`[@fingermarkglobal/api]: Save order FSM message recieved:`, message);
    return message;
  }
});

const createSaveOrderMachine = ({ payload = null, timeout = 30 } = {}) =>
  createMachine<{ payload: SaveOrderPayload; timeout: number; data: unknown }>(
    {
      id: 'saveOrderMachine',
      initial: 'processing',
      context: {
        payload,
        timeout,
        data: null
      },
      states: {
        processing: {
          invoke: {
            src: ({ payload, timeout }) => saveOrder(payload, timeout),
            onDone: {
              target: 'success',
              actions: ['populateMessage']
            },
            onError: {
              target: 'error',
              actions: ['populateMessage']
            }
          }
        },
        success: {
          on: {
            RETRY: 'processing'
          }
        },
        error: {
          type: 'final',
          entry: ['populateMessage']
        }
      }
    },
    {
      actions: {
        populateMessage
      }
    }
  );

export { createSaveOrderMachine };
